module.exports = __webpack_public_path__ + "78c28465643a20597ce65eee037a7675.ttf";